import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ProduktService } from "../produkt.service";
import { ProduktSearchPanelComponent } from "./produkt-search-panel/produkt-search-panel.component";
import { ProduktSearchResultComponent } from "./produkt-search-result/produkt-search-result.component";
import { ProduktSearchComponent } from "./produkt-search.component";

@NgModule({
    imports: [
        RaskCommonModule,
        ProduktSearchComponent,
        ProduktSearchPanelComponent,
        ProduktSearchResultComponent
    ],
    providers: [ProduktService]
})
export class ProduktSearchModule { }
